(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminUserAccountController', NasracAdminUserAccountController);
    window.localStorage.removeItem("DataTables_usersearchbar_/");
    NasracAdminUserAccountController.$inject = ['$scope', '$state',  'NasracPackage', 'NasracAdminUserAccount', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal' ];

    function NasracAdminUserAccountController ($scope, $state, NasracPackage, NasracAdminUserAccount, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracAdminUserAccounts = [];
        vm.nasracAdminUserAccounts = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};
        var dacAdminNonPrivilegeRoles = ['Administrators', 'Billing Administrator', 'Billing User'];

        loadAll();

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();

        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-admin-user-accounts/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },

            data: function(data, dtInstance) {
                data.columns.shift();
                data.order[0].column = data.order[0].column - 1;
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
	.withBootstrap()
	.withPaginationType('full_numbers')
	.withDisplayLength(25)

	.withOption('createdRow', function (row) {
		// Recompiling so we can bind Angular directive to the DT
	        $compile(angular.element(row).contents())($scope);
	})
	.withOption('saveState', true)
	.withOption('order', [1, 'asc'])
    .withButtons([
        {
            text: 'Export',
            extend: "excelHtml5",
            title:"NasracAdminUserAccount",
            action: function (e, dt, node, config) {
                NasracPackage.downloadUserAccounts().$promise
                    .then(function (data) {
                        var url = URL.createObjectURL(data.response);
                        var link = document.createElement("a");
                        link.href = url;

                        //set the visibility hidden so it will not effect on your web-layout
                        link.style = "visibility:hidden";
                        link.download = "NAS_RAC-Admin_User_Accounts.xlsx"; //this is an example file to download, use yours

                        //this part will append the anchor tag and remove it after automatic click
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    });
            },
            exportOptions: {
                columns: ':visible'
            },
            //CharSet: "utf8",
            exportData: { decodeEntities: true }
        }
    ])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '85px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('login').withTitle('Login'),
              DTColumnBuilder.newColumn('displayName').withTitle('Display Name'),
              //DTColumnBuilder.newColumn('password').withTitle('Password'),
              DTColumnBuilder.newColumn('siteId').withTitle('Site Id'),
              DTColumnBuilder.newColumn('firstName').withTitle('First Name'),
              DTColumnBuilder.newColumn('lastName').withTitle('Last Name'),

              DTColumnBuilder.newColumn('email').withTitle('Email'),
              DTColumnBuilder.newColumn('createdDate').withTitle('Created Date').renderWith(function(data,type,full) {
            	  data = $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ');
            	  if (data) { data += abbr; }
                  return data;

              }),
              DTColumnBuilder.newColumn('lastLoginTime').withTitle('Last Login Time').renderWith(function(data,type,full) {
            	  data = $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ');
            	  if (data) { data += abbr; }
                  return data;

              })/*,
              DTColumnBuilder.newColumn('authorizeFlag').withTitle('AuthorizeFlag'),
              DTColumnBuilder.newColumn('notifyFlag').withTitle('NotifyFlag'),
              DTColumnBuilder.newColumn('createdDate').withTitle('CreatedDate'),
              DTColumnBuilder.newColumn('lastLoginTime').withTitle('LastLoginTime'),
              DTColumnBuilder.newColumn('lastActivityTime').withTitle('LastActivityTime'),
              DTColumnBuilder.newColumn('lastPasswordChangeTime').withTitle('LastPasswordChangeTime'),
              DTColumnBuilder.newColumn('lastLockOutTime').withTitle('LastLockOutTime'),
              DTColumnBuilder.newColumn('userOnlineFlag').withTitle('UserOnlineFlag'),
              DTColumnBuilder.newColumn('userLockOutFlag').withTitle('UserLockOutFlag'),
              DTColumnBuilder.newColumn('userPasswordUpdFlag').withTitle('UserPasswordUpdFlag')*/

        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }

        function loadAll() {
            NasracAdminUserAccount.query(function(result) {
                vm.nasracAdminUserAccounts = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
        	if (Principal.hasAnyAuthority(['Administrators'])){
        		return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        	} else {
        		if(anyRolesMatch(data.securityRoles, dacAdminNonPrivilegeRoles) ) {
            		return GUIUtils.getActionsTemplate(data, $state.current.name, []);
            	} else {
            		return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
            	}
        	}

        }

        function search() {
         vm.dtInstance.reloadData();
        }

        function anyRolesMatch(userRoles, nonPrivilegeRoles) {
        	  return userRoles.some(function(role) {
        		  return nonPrivilegeRoles.includes(role.securityRoleName);
        	  });
        }

    }
})();
